import { render, staticRenderFns } from "./Soils.vue?vue&type=template&id=60ff199a"
import script from "./Soils.vue?vue&type=script&lang=js"
export * from "./Soils.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports